import { msg } from '@lingui/core/macro';

import { filterAction } from '@/shared/filters/filter-action';
import { listPageAction } from '@/shared/patterns/list-search';
import { action } from '@/shared/screen/define';

import { preparedAction } from './beneficiary-limits.screen';
import { paymentListFilters } from './payment.filters';

// Ações da aba Pagamentos (U4a, U23/U24), acrescentadas ao manifesto do detalhe. Leve: o fio entra pela tela.
//
// O agente **só prepara**: Boletos de cobrança, Tributos, Contas de consumo, Aprovar e Reprovar abrem o formulário ou o
// diálogo de senha e código; nenhum código de barras, valor, documento ou data passa pela ferramenta. Ficam fora,
// de propósito: Detalhes, Copiar código de barras, Cancelar e Comprovante (presos a uma linha: precisariam de chave de
// alvo, que a trava `agent-tool-targets` recusa) e Exportar PDF (feito só na tela).

/** "Atualizar" (`PaymentHeaderList.tsx:22-26,47-53`): a lista e o saldo da conta. */
export const paymentsRefresh = action({
  id: 'bankAccount.payments.refresh',
  kind: 'read',
  label: msg`Atualizar`,
  description: msg`Busca de novo a lista de pagamentos e o saldo da conta aberta. Nada é alterado.`,
  run: () => undefined,
});

export const paymentsFilter = filterAction('bankAccount.payments.filter', paymentListFilters, {
  description: msg`Filtra a lista de pagamentos da conta aberta: pay_searchString (todos os campos), pay_status (Approved, Pending, Rejected, Timeout, Canceled, Error, Processing, Finished), pay_paymentDate (data do pagamento, AAAA-MM-DD) e pay_amount (valor do pagamento, como 1.234,56). Filtro omitido é limpo.`,
});

export const paymentsPage = listPageAction('bankAccount.payments.page');

/** A paginação da lista na conta transitória, no manifesto dela. */
export const transitoryPaymentsPage = listPageAction('bankAccount.transitory.payments.page');

/** "Boletos de cobrança" (`PaymentHeader.tsx:42-49`): a pessoa consulta o código, confere e confirma com senha e código MFA. */
export const paymentsBankSlip = preparedAction(
  'bankAccount.payments.bankSlip',
  msg`Boletos de cobrança`,
  'write',
  msg`Abre o formulário Realizar pagamento (boleto de cobrança) da conta aberta, em branco. Quem digita o código de barras ou a linha digitável, consulta, confere o beneficiário, o valor e a data e confirma com a senha e o código MFA é a pessoa: esta ferramenta não paga nada. Não recebe entrada.`,
  msg`Realizar pagamento`,
);

/** "Tributos" (`PaymentHeader.tsx:51-59`, `TaxSlip.tsx`): o tipo de tributo, o código ou o formulário, e a senha e o código MFA. */
export const paymentsTaxSlip = preparedAction(
  'bankAccount.payments.taxSlip',
  msg`Tributos`,
  'write',
  msg`Abre o formulário Realizar pagamento de tributos (tributos com código de barras, boleto FGTS, DARF com ou sem código de barras, ICMS e IPVA) da conta aberta, em branco. Quem escolhe o tipo, digita o código ou preenche a guia, confere e confirma com a senha e o código MFA é a pessoa: esta ferramenta não paga nada. Não recebe entrada.`,
  msg`Realizar pagamento | Tributos`,
);

/** "Contas de consumo" (`PaymentHeader.tsx:61-69`): água, gás, energia e telefone, com senha e código MFA. */
export const paymentsConsumptionBill = preparedAction(
  'bankAccount.payments.consumptionBill',
  msg`Contas de consumo`,
  'write',
  msg`Abre o formulário Realizar pagamento de conta de consumo (água, gás, energia e telefone) da conta aberta, em branco. Quem digita o código, consulta, confere o valor e a data e confirma com a senha e o código MFA é a pessoa: esta ferramenta não paga nada. Não recebe entrada.`,
  msg`Realizar pagamento | Contas de consumo`,
);

/** "Aprovar" e "Reprovar" do cabeçalho da lista (`PaymentHeaderList.tsx:33-46`): pedem senha e código MFA. */
export const paymentsApprove = preparedAction(
  'bankAccount.payments.approve',
  msg`Aprovar`,
  'write',
  msg`Prepara a aprovação dos pagamentos marcados na página aberta da lista da conta. Só abre o diálogo de senha e código MFA, com a quantidade e o total: esta ferramenta não aprova nada. Não recebe entrada; os alvos são as linhas marcadas na página aberta, todas aguardando aprovação.`,
  msg`Aprovar pagamento`,
);

export const paymentsReject = preparedAction(
  'bankAccount.payments.reject',
  msg`Reprovar`,
  'destructive',
  msg`Prepara a reprovação dos pagamentos marcados na página aberta da lista da conta. Só abre o diálogo de senha e código MFA, com a quantidade e o total: esta ferramenta não reprova nada. Não recebe entrada; os alvos são as linhas marcadas na página aberta, todas aguardando aprovação.`,
  msg`Reprovar pagamento`,
);

/** As ações novas do detalhe, para o `actions` do manifesto. */
export const PAYMENT_ACTIONS = [paymentsRefresh, paymentsFilter, paymentsPage, paymentsBankSlip, paymentsTaxSlip, paymentsConsumptionBill, paymentsApprove, paymentsReject];
